import * as React from 'react'
import {
  Datagrid,
  List,
  Edit,
  SimpleForm,
  BooleanField,
  NumberField,
  TextField,
  BooleanInput,
  NumberInput,
  ShowButton,
  Pagination,
  Create,
  TextInput,
} from 'react-admin'

export const OnboardingConfigList = props => (
  <List
    {...props}
    title="Onboarding Steps"
    perPage={100}
    sort={{ field: 'index', order: 'ASC' }}
    pagination={<Pagination rowsPerPageOptions={[]} />}
  >
    <Datagrid>
      <TextField source="name" />
      <NumberField source="index" />
      <BooleanField source="enabled" />
      <ShowButton label="" />
    </Datagrid>
  </List>
)

export const OnboardingConfigEdit = props => (
  <Edit {...props} title="Edit Onboarding Step" undoable={false}>
    <SimpleForm>
      <NumberInput source="index" />
      <BooleanInput source="enabled" />
    </SimpleForm>
  </Edit>
)

export const OnboardingConfigCreate = props => (
  <Create {...props} title="Add an Onboarding Step">
    <SimpleForm>
      <TextInput source="name" options={{ fullWidth: true }} />
      <NumberInput source="index" />
      <BooleanInput source="enabled" />
    </SimpleForm>
  </Create>
)
